import React from 'react';
import { Map } from 'lucide-react';
const servedZips = [{
  zip: '94109',
  name: 'Russian Hill / Nob Hill',
  transactions: 28,
  rank: 1
}, {
  zip: '94123',
  name: 'Marina District',
  transactions: 22,
  rank: 2
}, {
  zip: '94117',
  name: 'Haight-Ashbury / Cole Valley',
  transactions: 18,
  rank: 3
}, {
  zip: '94114',
  name: 'Castro / Noe Valley',
  transactions: 15,
  rank: 5
}, {
  zip: '94941',
  name: 'Mill Valley',
  transactions: 12,
  rank: 4
}, {
  zip: '94965',
  name: 'Sausalito',
  transactions: 8,
  rank: 6
}];
export function MarketsServed() {
  return <section className="py-12 px-6 md:px-12 max-w-6xl mx-auto pt-[12px] pb-[12px]" data-id="element-274">
      <div className="bg-white rounded-3xl p-8 md:p-10 shadow-premium border border-brand-light" data-id="element-275">
        <div className="flex items-center gap-3 mb-8" data-id="element-276">
          <div className="w-12 h-12 rounded-full bg-brand-sage flex items-center justify-center text-brand-forest" data-id="element-277">
            <Map size={24} data-id="element-278" />
          </div>
          <div data-id="element-279">
            <h2 className="text-2xl font-serif text-brand-dark" data-id="element-280">
              Markets served
            </h2>
            <p className="text-sm text-brand-muted" data-id="element-281">
              ZIP-level performance across the Bay Area
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-282">
          {servedZips.map(z => <div key={z.zip} className="flex items-center gap-3 px-4 py-3 bg-brand-sage/50 border border-brand-light rounded-xl hover:border-brand-forest/30 transition-colors" data-id="element-283">
            
              <div className="flex flex-col items-center justify-center w-12" data-id="element-284">
                <span className="font-mono text-sm font-medium text-brand-forest" data-id="element-285">
                  {z.zip}
                </span>
              </div>
              <div className="flex-1 min-w-0" data-id="element-286">
                <p className="text-sm font-medium text-brand-dark truncate" data-id="element-287">
                  {z.name}
                </p>
                <p className="text-xs text-brand-muted" data-id="element-288">
                  <span className="font-mono" data-id="element-289">{z.transactions}</span>{' '}
                  transactions · Rank #{z.rank}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}